const MIN_RECOMMENDED_TO_SHOW = 3;

export const canShowRecommended = recommendations =>
  recommendations?.length >= MIN_RECOMMENDED_TO_SHOW;
